import { capitalize, startCase } from 'lodash';

import { RELEVANCE_SORT_FIELD_NAME } from '~/constants/relevanceSortFieldName';

export type GetConfigFieldLabelOptions = {
  /**
   * @TODO(WORK-479): Remove this option when the ui2026 flag is removed, keeping the "Title & metadata" copy.
   */
  ui2026?: boolean;
};

export const getConfigFieldLabel = (name: string, { ui2026 = false }: GetConfigFieldLabelOptions = {}) => {
  switch (name) {
    case 'name':
      return 'Name';
    case 'dateCreated':
    case 'created':
      return 'Date created';
    case 'updated':
      return 'Last updated';
    case 'dateModified':
      return 'Date modified';
    case 'dateTaken':
      return 'Date taken';
    case 'dateUploaded':
      return 'Date uploaded';
    case 'ext':
      return 'Extension';
    case 'size':
      return 'Size';
    case 'titleAndMetadata':
      // @TODO(WORK-479): Return "Title & metadata" unconditionally when the ui2026 flag is removed.
      return ui2026 ? 'Title & metadata' : 'Asset details';
    case 'type':
      return 'Type';
    case 'lastModified':
      return 'Date modified';
    case 'newest':
      return 'Date created';
    case 'oldest':
      return 'Date created';
    case 'aToZ':
      return 'Name';
    case 'zToA':
      return 'Name';
    case 'customSort':
      return 'Custom sort';
    case RELEVANCE_SORT_FIELD_NAME:
      return 'Relevance';
    case 'tagCount':
      return 'Tag count';
    case 'boardCount':
      return 'Board count';
    case 'openCommentCount':
      return 'Comment count';
    case 'resolution':
      return 'Resolution';
    case 'uploadedBy':
      return 'Uploaded by';
    case 'firstName':
      return 'First name';
    case 'lastName':
      return 'Last name';
    case 'expirationDate':
      return 'Expiration date';
    default:
      return capitalize(startCase(name));
  }
};
